// src/components/ui/button.js
import React from 'react';
import { cn } from '../../lib/utils'; // Path relative to button.js

const Button = ({ children, onClick, className = '', ...props }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'px-4 py-2 rounded-md font-medium transition-colors duration-200',
        'bg-green-500/20 text-green-400 hover:bg-green-500/30 hover:text-green-300',
        className // Apply any additional class names passed from parent
      )}
      {...props} // Pass any other props down to the button element
    >
      {children}
    </button>
  );
};

export default Button;
